import PropTypes from 'prop-types';
import { Component } from 'react';
import lodash from 'lodash';
import styles from './UserPermissionDisplay.scss';
import icons from 'styles/icons/icons.scss';

export class UserPermissionDisplay extends Component {
    handleClick(e) {
        const sub = lodash.get(this.props, 'user.sub');

        if (this.props.isSelected) {
            this.props.changeSelection('remove', sub);
        } else {
            this.props.changeSelection('add', sub);
        }
    }

    render() {
        const {
            user,
            groups,
            permissionProperties,
            isSelected,
            viewSummaryMode,
            isUpdated
        } = this.props;
        const userGroups = lodash.filter(groups, g => lodash.includes(user.groups, g.id));
        const {binderPermissions} = user;
        const hasAccess = lodash.some(binderPermissions,
            bp => bp.name === 'hasBinderAccess' && bp.value === 'yes');

        const displayClass = isSelected
            ? styles.userPermissionDisplaySelected
            : styles.userPermissionDisplay;

        return (
            <div className={displayClass} onClick={this.handleClick.bind(this)} data-cy="UserPermissionDisplay-UserPermissionDisplay">
                <DisplayHeader user={user} groups={userGroups}
                    hasAccess={hasAccess} isUpdated={isUpdated} />
                <DisplayPermissions permissionProperties={permissionProperties}
                    binderPermissions={binderPermissions}
                    viewSummaryMode={viewSummaryMode} />
            </div>
        );
    }
}

export const DisplayHeader = ({user, groups, hasAccess, isUpdated}) => {
    const displayNameClass = isUpdated ? styles.displayNameUpdated : styles.displayName;
    return (
        <div className={styles.displayHeader} data-cy="UserPermissionDisplay-DisplayHeader">
            <div className={styles.stackedPair}>
                <span className={displayNameClass} data-cy="UserPermissionDisplay-displayName">{user.displayName}</span>
                <span className={styles.emailAddress} data-cy="UserPermissionDisplay-emailAddress">{user.emailAddress}</span>
            </div>
            <div className={styles.viewGroups}>
                <span className={styles.viewGroupsLabel} data-cy="UserPermissionDisplay-groups">groups</span>
                <div className={styles.viewGroupsContainer}>
                    <div className={styles.viewGroupsPanel} data-cy="UserPermissionDisplay-displayName">
                        {lodash.map(groups, g => <span key={g.id}>{g.displayName}</span>)}
                    </div>
                </div>
            </div>
            <div className={styles.hasAccess} data-cy="UserPermissionDisplay-hasAccess">
                <span className={hasAccess ? styles.hasAccessValueYes : styles.hasAccessValueNo} data-cy="UserPermissionDisplay-Access">
                    {hasAccess ? 'has access' : 'does not have access'}
                </span>
                <span className={styles.permissionsRider} data-cy="UserPermissionDisplay-permissionsRider">
                    {hasAccess ? 'Showing permissions for user' : 'Showing default permissions for user'}
                </span>
            </div>
        </div>
    );
};

export const DisplayPermissions = ({binderPermissions, permissionProperties, viewSummaryMode}) => {
    if (viewSummaryMode) {
        return null;
    }
    const renderedBinderPermissions = lodash.map(binderPermissions, bp => {
        const {name, value, isRestricted} = bp;
        const permissionProperty = permissionProperties[name];
        if (name === 'hasBinderAccess' || !permissionProperty) {
            return null;
        }
        
        const {displayName} = permissionProperty;
        const displayNameClass = isRestricted ? styles.permissionsNameRestricted : styles.permissionsName;
        const valueClass = isRestricted ? styles.value : styles.valueRestricted;

        const lockItem = isRestricted ?
            <span className={icons.materialIcons + ' ' + icons.smaller + ' ' + valueClass}>lock</span>
            : null;

        return (
            <div className={styles.displayItem} key={name} data-cy="UserPermissionDisplay-DisplayPermissions">
                <span className={displayNameClass} title={name} data-cy="UserPermissionDisplay-displayName">{displayName}{lockItem}</span>
                <span className={valueClass} data-cy="UserPermissionDisplay-isRestricted" title={isRestricted ? 'cannot be changed' : ''}>{value}</span>
            </div>
        );
    });

    return (
        <div className={styles.displayPermissions} data-cy="UserPermissionDisplay-renderedBinderPermissions">
            {renderedBinderPermissions}
        </div>
    );
};

UserPermissionDisplay.propTypes = {
    user: PropTypes.shape({
        sub: PropTypes.string,
        displayName: PropTypes.string,
        emailAddress: PropTypes.string,
        groups: PropTypes.arrayOf(PropTypes.string),
        binderPermissions: PropTypes.objectOf(PropTypes.shape({
            name: PropTypes.string,
            isRestricted: PropTypes.bool,
            value: PropTypes.string
        }))
    }),
    groups: PropTypes.objectOf(PropTypes.shape({
        id: PropTypes.string,
        displayName: PropTypes.string,
        description: PropTypes.string
    })),
    permissionProperties: PropTypes.objectOf(PropTypes.shape({
        name: PropTypes.string,
        displayName: PropTypes.string,
        value: PropTypes.string,
        allowedValues: PropTypes.arrayOf(PropTypes.string)
    })),
    changeSelection: PropTypes.func.isRequired,
    isSelected: PropTypes.bool.isRequired,
    isUpdated: PropTypes.bool.isRequired,
};

export default UserPermissionDisplay;